import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { interval } from 'rxjs/observable/interval';

export class TicketService {
  private timeLeft$ = new BehaviorSubject<number>(0);
  private reserveTime$ = new BehaviorSubject<number>(0);
  private isOver$ = new BehaviorSubject<boolean>(false);
  private show$ = new BehaviorSubject<boolean>(false);

  public setIsOver(): void {
    this.isOver$.next(true);
  }

  public setReserveTime(reserveTime: number): void {
    this.reserveTime$.next(reserveTime);
  }

  public setTimeLeft(minutes: number): void {
    if (minutes <= 0) {
      this.timeLeft$.next(0);
      this.timeLeft$.complete();
      return;
    }

    const timeLeft = new Date().getTime() + 1000 * minutes;

    this.timeLeft$.next(timeLeft);
    this.show$.next(true);
  }

  public getIsOver(): Observable<boolean> {
    return this.isOver$.asObservable().distinctUntilChanged();
  }

  public getReserveTime(): Observable<number> {
    return this.reserveTime$.asObservable().distinctUntilChanged();
  }

  public show() {
    return this.show$.asObservable().distinctUntilChanged();
  }

  public calculateTime(): Observable<any> {
    return interval(50)
      .combineLatest(this.getTimeLeft())
      .switchMap(([, time]) => {
        const newTime = time - new Date().getTime();
        if (newTime <= 0) {
          this.setIsOver();
        }
        return Observable.of(newTime / 1000);
      })
      .takeWhile((time) => time > 0);
  }

  public getTimeLeft(): Observable<any> {
    return this.timeLeft$.asObservable();
  }
}

// tslint:disable-next-line:variable-name
export const TicketServiceFactory = () => new TicketService();

export const ticketService = TicketServiceFactory();
